import { useState } from "react";
import { Photo, type PhotoProps } from "@/components/shared/Photo";

type ContentImageProps = {
  src?: string;
  alt: string;
  height?: number;
  className?: string;
  rounded?: boolean;
  photoDim?: PhotoProps["dim"];
  photoLabel?: string;
};

/**
 * 优先加载静态图；缺失或失败时回退渐变占位（产品后期按约定路径丢文件即可生效）。
 */
export function ContentImage({
  src,
  alt,
  height = 180,
  className = "",
  rounded = true,
  photoDim = "city",
  photoLabel,
}: ContentImageProps) {
  const [failed, setFailed] = useState(false);
  const showPhoto = !src || failed;

  if (showPhoto) {
    return (
      <Photo
        label={photoLabel ?? alt}
        height={height}
        dim={photoDim}
        rounded={rounded}
        className={className}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`w-full object-cover ${rounded ? "rounded-xl" : ""} ${className}`}
      style={{ height }}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
